// eslint-disable-next-line import/no-cycle
import { axiosService } from '../system/axios.service'

const addFiles = (id, body) => {
  const route = `/vehicleIncidents/${id}/files`
  return axiosService.post(true, route, null, body)
}

export const vehicleIncidentService = { addFiles }
